import * as THREE from 'three';

export class FikoSilhouetteShader extends THREE.ShaderMaterial {
  constructor() {
    super({
      uniforms: {
        uOutlineWidth: { value: 0.03 }, // Default outline width
        uOutlineColor: { value: new THREE.Color(0x000000) }, // Default black color
      },
      vertexShader: `
        void main() {
          vec3 expandedPosition = position + normal * uOutlineWidth;
          gl_Position = projectionMatrix * modelViewMatrix * vec4(expandedPosition, 1.0);
        }
      `,
      fragmentShader: `
        uniform vec3 uOutlineColor;
        void main() {
          gl_FragColor = vec4(uOutlineColor, 1.0);
        }
      `,
      side: THREE.BackSide, // Crucial for outline effect
      depthWrite: false, // Don't write to depth buffer for outline
      dithering: true,
    });
  }
}
